import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin } from 'lucide-react'
import { SiFacebook, SiInstagram, SiLinkedin } from 'react-icons/si'
import logo from '../assets/images/logo-footer.png'

const Footer = () => {
  const quickLinks = [
    { name: 'Início', path: '/' },
    { name: 'Sobre', path: '/sobre' },
    { name: 'Serviços', path: '/servicos' },
    { name: 'Portfólio', path: '/portfolio' },
    { name: 'Contato', path: '/contato' },
  ]

  const services = [
    'Ar Condicionado Residencial',
    'Climatização Comercial',
    'Câmaras Frigoríficas',
    'Manutenção Preventiva',
    'Projetos Personalizados',
  ]

  const socialLinks = [
    {
      name: 'Facebook',
      url: '#',
      icon: SiFacebook,
      ariaLabel: 'Visite nossa página no Facebook',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/tech.glacial?igsh=czQyenJhYWFuM2Jj',
      icon: SiInstagram,
      ariaLabel: 'Siga-nos no Instagram',
    },
    {
      name: 'LinkedIn',
      url: '#',
      icon: SiLinkedin,
      ariaLabel: 'Conecte-se conosco no LinkedIn',
    },
  ]

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="bg-gray-900 text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src={logo}
                className="h-14 w-auto"
                alt="Tech Glacial - Logo da empresa"
                loading="lazy"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Líder em soluções de refrigeração e climatização, oferecendo tecnologia de ponta
              e atendimento personalizado.
            </p>
            <nav aria-label="Redes sociais">
              <h3 className="sr-only">Nossas redes sociais</h3>
              <div className="flex space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target={social.url !== '#' ? '_blank' : undefined}
                    rel={social.url !== '#' ? 'noopener noreferrer' : undefined}
                    aria-label={social.ariaLabel}
                    className="text-gray-400 hover:text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded p-1"
                  >
                    <social.icon className="h-5 w-5" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </nav>
          </div>

          {/* Quick Links */}
          <nav aria-labelledby="quick-links-heading">
            <h4 id="quick-links-heading" className="text-lg font-semibold mb-4">
              Links Rápidos
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={handleLinkClick}
                    className="text-gray-400 hover:text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded inline-block"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Services */}
          <section aria-labelledby="services-heading">
            <h4 id="services-heading" className="text-lg font-semibold mb-4">
              Nossos Serviços
            </h4>
            <ul className="space-y-2 text-gray-400">
              {services.map((service, index) => (
                <li key={index}>{service}</li>
              ))}
            </ul>
          </section>

          {/* Contact Info */}
          <section aria-labelledby="contact-heading">
            <h4 id="contact-heading" className="text-lg font-semibold mb-4">
              Contato
            </h4>
            <address className="not-italic space-y-3">
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-blue-400 flex-shrink-0" aria-hidden="true" />
                <a
                  href="tel:+5547992845121"
                  className="text-gray-400 hover:text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded"
                  aria-label="Telefone: (47) 99284-5121"
                >
                  (47) 99284-5121
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-blue-400 flex-shrink-0" aria-hidden="true" />
                <a
                  href="mailto:contato@techglacial.com.br"
                  className="text-gray-400 hover:text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded"
                  aria-label="Email: contato@techglacial.com.br"
                >
                  contato@techglacial.com.br
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-blue-400 mt-1 flex-shrink-0" aria-hidden="true" />
                <a
                  href="https://maps.google.com/?q=R.+Alziro+Zarur,+180+Bom+Retiro+Joinville+SC"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded"
                  aria-label="Endereço: R. Alziro Zarur, 180, Bom Retiro, Joinville, SC. Abrir no Google Maps"
                >
                  R. Alziro Zarur, 180<br />
                  Bom Retiro – Joinville/SC, 89222-160
                </a>
              </div>
            </address>
          </section>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p className="mb-2">
            &copy; {new Date().getFullYear()} Tech Glacial. Todos os direitos reservados.
          </p>
          <p>
            Desenvolvido por{' '}
            <a
              href="https://www.andie.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded"
              aria-label="Visite o site do desenvolvedor AndieDotDev"
            >
              AndieDotDev
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer